import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Col, Row } from "react-bootstrap";
import closeIcon from "../../assets/icons/Notshow.svg";
import Modal from "react-bootstrap/Modal";

import FormDisabled from "./FormDetailsDisabled";

import { fetchFormById } from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const FormDetailsModal = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchFormById(props.formId));
  }, []);

  const existingFormContent = useSelector((state) => state.user.formById);
  const [formComponents, setFormComponents] = useState([]);

  useEffect(() => {
    if (existingFormContent && existingFormContent?.data) {
      if (existingFormContent?.data?.[0]?.sections) {
        const updatedSections = existingFormContent?.data?.[0]?.sections?.map(
          (section) => {
            const updatedChildren = section?.children?.map((child) => {
              return { ...child, id: Math.ceil(Math.random() * 1000) };
            });
            return {
              ...section,
              iscomplete: section?.iscomplete === 1 ? true : false,
              children: updatedChildren,
              id: Math.ceil(Math.random() * 1000),
            };
          }
        );

        setFormComponents(updatedSections);
      }
    }
  }, [existingFormContent]);

  useEffect(() => {
    localStorage.setItem("formComponents", JSON.stringify(formComponents));
  }, [formComponents]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <>
      <style jsx>{`
        #formName .modal-content {
          background: #fff;
        }
      `}</style>
      <Modal
        id="formDetails"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        className="form-detail p-5"
        centered
      >
        <Row>
          <Col className="d-flex justify-content-end pe-0 ">
            <div
              className="cursor-pointer"
              onClick={() => {
                props.close();
              }}
            >
              <img className="" src={closeIcon} alt="" /> &nbsp;&nbsp;
              {/* Close */}
              {t("Close")}
            </div>
          </Col>
        </Row>

        <div className="mt-5">
          <div className="disable-overlay"></div>
          <FormDisabled formComponents={formComponents} showMenu={false} />
        </div>
      </Modal>
    </>
  );
};

export default FormDetailsModal;
